<template>
  <el-dialog
    id="editDialog"
    :title="editInfo && editInfo.id ? '修改客户' : '新增客户'"
    :visible="visible"
    append-to-body
    modal-append-to-body
    width="500px"
    @close="$emit('close', false)"
  >
    <el-form
      :model="editInfo"
      label-position="right"
      label-width="100px"
      ref="editFormRef"
      :rules="{
        name: $ruleUtil.name('客户名称'),
        phoneNumber: $ruleUtil.simple({
          fieldName: '联系方式',
          required: true,
          max: 20,
        }),
        address: $ruleUtil.simple({
          fieldName: '联系地址',
          required: true,
          min: 2,
          max: 200,
        }),
        customerGroupId: $ruleUtil.simple({
          fieldName: '客户分组',
          handleType: '选择',
          required: false,
        }),
        remark: $ruleUtil.simple({
          fieldName: '备注',
          required: false,
          max: 200,
        }),
      }"
      v-if="editInfo"
    >
      <el-form-item label="客户名称" prop="name">
        <el-input
          v-model="editInfo.name"
          placeholder="请输入客户名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="联系方式" prop="phoneNumber">
        <el-input
          v-model="editInfo.phoneNumber"
          placeholder="请输入联系方式"
        ></el-input>
      </el-form-item>
      <el-form-item label="联系地址" prop="address">
        <el-input
          type="textarea"
          :autosize="{ minRows: 3, maxRows: 6 }"
          v-model="editInfo.address"
          placeholder="请输入联系地址"
        ></el-input>
      </el-form-item>
      <el-form-item label="客户分组" prop="customerGroupId">
        <CustomerGroupSelectDialog
          :value="editInfo.customerGroup"
          @select="selectCustomerGroup"
        ></CustomerGroupSelectDialog>
      </el-form-item>
      <el-form-item label="默认标识" prop="defaultMark">
        <el-tooltip
          slot="label"
          content="设置此客户是否是默认客户，默认客户将会在选择页面自动带出"
          placement="top"
        >
          <span>
            <i class="el-icon-question"></i>
            默认标识
          </span>
        </el-tooltip>
        <el-radio-group v-model="editInfo.defaultMark">
          <el-radio :label="true">
            <span v-fmtype="'success'">默认</span>
          </el-radio>
          <el-radio :label="false">
            <span v-fmtype="'warning'">非默认</span>
          </el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input
          type="textarea"
          :autosize="{ minRows: 3, maxRows: 6 }"
          v-model="editInfo.remark"
          placeholder="请输入备注信息"
        ></el-input>
      </el-form-item>
      <el-form-item label="冻结状态" prop="frozen">
        <el-radio-group v-model="editInfo.frozen">
          <el-radio :label="false">
            <span v-fmtype="'success'">未冻结</span>
          </el-radio>
          <el-radio :label="true">
            <span v-fmtype="'danger'">已冻结</span>
          </el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="$emit('close', false)">取 消</el-button>
      <el-button type="primary" @click="edit">
        {{ editInfo && editInfo.id ? "修 改" : "新 增" }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "Rterpv2WebCustomerAddNewDialog",
  props: {
    id: {
      type: String,
      default: null,
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    visible: {
      handler(val) {
        if (val) {
          setTimeout(() => {
            this.initData();
          }, 50);
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      editInfo: {},
    };
  },

  mounted() {},

  methods: {
    async initData() {
      this.editInfo = {
        name: null,
        phoneNumber: null,
        address: null,
        customerGroupId: null,
        customerGroup: null,
        defaultMark: false,
        remark: null,
        frozen: false,
      };
      if (this.id) {
        let resultRes = await this.$api.customer_findById(this.id, {
          showLoading: true,
          loadingParam: {
            target: "#editDialog > *",
            lock: true,
          },
        });
        if (resultRes && resultRes.success) {
          this.editInfo = {
            ...resultRes.data,
          };
        }
      } else {
        let res = await this.$api.customerGroup_getDefault();
        if (res && res.success) {
          this.editInfo.customerGroupId = res.data.id;
          this.editInfo.customerGroup = res.data;
        }
      }
    },
    selectCustomerGroup(item) {
      if (item) {
        this.editInfo.customerGroupId = item.id;
        this.editInfo.customerGroup = item;
      } else {
        this.editInfo.customerGroupId = null;
        this.editInfo.customerGroup = {};
      }
    },

    async edit() {
      this.$refs.editFormRef.validate(async (valid) => {
        if (!valid) {
          return;
        }
        let requestRes = this.editInfo.id
          ? await this.$api.customer_update(this.editInfo, {
              showLoading: true,
              loadingParam: {
                target: "#editDialog > *",
                lock: true,
                text: "修改中...",
              },
            })
          : await this.$api.customer_addNew(this.editInfo, {
              showLoading: true,
              loadingParam: {
                target: "#editDialog > *",
                lock: true,
                text: "新增中...",
              },
            });
        if (requestRes && requestRes.success) {
          this.$emit("close", true);
        }
      });
    },
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/CustomerAddNewDialog.vue